package com.ervasstudio.tracoemovimento.model

import com.ervasstudio.tracoemovimento.util.Res.MyColors.AccentYellow
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.graphics.Colors

enum class Paginas(val cor: Color.Rgb, val rota: String) {
    INÍCIO(Colors.White, "/"),
    PROJECTO(AccentYellow, "/projecto/"),
    SOBRE(Colors.Red, "/sobre/"),
    BLOG(Colors.Green, "/blog/"),
    CURSOS(Colors.White, "/cursos/"),

    `MEUS CURSOS`(Colors.White,"/cursos/meuscursos/"),
    LOGIN(Colors.White,"/cursos/login/"),
    SIGNUP(Colors.White,"/cursos/signup/"),
}